import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule, MatTableModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule } from '@angular/material';
import { ManageReferralComponent } from './manage-referral.component';
import { ManageReferralRoutingModule } from './manage-referral-routing.module';

@NgModule({
    declarations: [ManageReferralComponent],

    imports: [
        NgbModule,
        CommonModule,
        SharedModule,
        MatSelectModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        ReactiveFormsModule,
        FormsModule,
        ManageReferralRoutingModule
    ],
    providers: [],
    exports: [ManageReferralComponent],

})
export class ManageReferralModule { }
